import { colorLookup } from '@medifind/utils';
import { SVG } from './SVG';

const IconDoctorExperience = ({ size = 12, color }) => {
  const colorCode = colorLookup(color) ?? colorLookup('black');

  return (
    <SVG width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8 2.31579H9V1.15789C9 0.519316 8.4618 0 7.8 0H4.2C3.5382 0 3 0.519316 3 1.15789V2.31579H1.2C0.5382 2.31579 0 2.83511 0 3.47368V5.21053H12V3.47368C12 2.83511 11.4618 2.31579 10.8 2.31579ZM4.2 1.15789H7.8V2.31579H4.2V1.15789ZM7.2 6.94737H4.8V5.78947H0V9.8421C0 10.4807 0.5382 11 1.2 11H10.8C11.4618 11 12 10.4807 12 9.8421V5.78947H7.2V6.94737Z"
        fill={colorCode}
      />
    </SVG>
  );
};
export { IconDoctorExperience as default, IconDoctorExperience };
